var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-stepper",
    {
      staticClass: "ticket-generate-report",
      staticStyle: { "box-shadow": "none" },
      attrs: { vertical: "" },
      model: {
        value: _vm.dtCurrentStep,
        callback: function($$v) {
          _vm.dtCurrentStep = $$v
        },
        expression: "dtCurrentStep"
      }
    },
    [
      _c(
        "v-stepper-step",
        {
          attrs: {
            color: "secondary",
            editable: "",
            complete: _vm.dtCurrentStep > 1,
            step: "1"
          }
        },
        [
          _c("h2", { staticClass: "primary--text" }, [
            _vm._v(
              _vm._s(_vm.$t(_vm.lblSetting.ticketSelectInterventionReport))
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "v-stepper-content",
        { attrs: { step: "1" } },
        [
          _c(
            "v-layout",
            { attrs: { column: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "base-control-label-vertical",
                    {
                      attrs: {
                        label: _vm.$t(_vm.lblSetting.ticketIntervention)
                      }
                    },
                    [
                      _c("base-multi-select", {
                        attrs: {
                          options: _vm.coAppointments,
                          icon: "",
                          "item-value": "id",
                          "item-text": "name",
                          "return-object": false,
                          multiple: false
                        },
                        on: { change: _vm.handleChangeAppointment },
                        model: {
                          value: _vm.fkAppointment,
                          callback: function($$v) {
                            _vm.fkAppointment = $$v
                          },
                          expression: "fkAppointment"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "base-control-label-vertical",
                    {
                      attrs: {
                        required: "",
                        label: _vm.$t(_vm.lblSetting.ticketRangeDates)
                      }
                    },
                    [
                      _c("base-datetime-picker-range-vertical", {
                        attrs: { step: 15 },
                        model: {
                          value: _vm.coDates,
                          callback: function($$v) {
                            _vm.coDates = $$v
                          },
                          expression: "coDates"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "base-control-label-vertical",
                    {
                      attrs: {
                        label: _vm.$t(_vm.lblSetting.ticketInterventionNumberKm)
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          placeholder: _vm.$t(
                            _vm.lblSetting.ticketInterventionNumberKm
                          ),
                          solo: "",
                          suffix: "Km",
                          type: "number"
                        },
                        on: { change: _vm.handleNumberKm },
                        model: {
                          value: _vm.numberKm,
                          callback: function($$v) {
                            _vm.numberKm = $$v
                          },
                          expression: "numberKm"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                flat: "",
                outline: "",
                round: "",
                small: ""
              },
              on: {
                click: function($event) {
                  _vm.dtCurrentStep = 2
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t(_vm.lblSetting.ticketNext)))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-stepper-step",
        {
          attrs: {
            color: "secondary",
            complete: _vm.dtCurrentStep > 2,
            step: "2"
          }
        },
        [
          _c("h2", { staticClass: "primary--text" }, [
            _vm._v(_vm._s(_vm.$t(_vm.lblSetting.ticketReserve)))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "v-stepper-content",
        { attrs: { step: "2" } },
        [
          _c(
            "base-control-label-vertical",
            [
              _c("v-text-field", {
                staticClass: "white--bg",
                attrs: {
                  name: "description",
                  counter: _vm.textConfigs.textarea,
                  maxlength: _vm.textConfigs.textarea,
                  rows: 5,
                  "multi-line": "",
                  box: "",
                  required: ""
                },
                model: {
                  value: _vm.reserve,
                  callback: function($$v) {
                    _vm.reserve = $$v
                  },
                  expression: "reserve"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                small: "",
                flat: "",
                outline: "",
                round: ""
              },
              on: {
                click: function($event) {
                  _vm.dtCurrentStep = 3
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t(_vm.lblSetting.ticketNext)))]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { flat: "", round: "", small: "" },
              on: {
                click: function($event) {
                  _vm.dtCurrentStep = 1
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t(_vm.lblSetting.ticketPrevious)))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-stepper-step",
        {
          attrs: {
            color: "secondary",
            complete: _vm.dtCurrentStep > 3,
            step: "3"
          }
        },
        [
          _c("h2", { staticClass: "primary--text" }, [
            _vm._v(_vm._s(_vm.$t(_vm.lblSetting.shareByEmail)))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "v-stepper-content",
        { attrs: { step: "3" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs10: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      clearable: "",
                      label: _vm.$t(_vm.lblSetting.addEmail),
                      solo: ""
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.addEmail($event)
                      }
                    },
                    model: {
                      value: _vm.newEmail,
                      callback: function($$v) {
                        _vm.newEmail = $$v
                      },
                      expression: "newEmail"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "red--text body-2" }, [
                    _vm._v(_vm._s(_vm.errorMessage))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs2: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", color: "primary" },
                      on: { click: _vm.addEmail }
                    },
                    [
                      _c("v-icon", { attrs: { color: "white" } }, [
                        _vm._v("add")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.emails, function(email, i) {
            return _c(
              "v-layout",
              { key: i, attrs: { row: "" } },
              [
                _c(
                  "v-flex",
                  {
                    staticClass: "text-xs-left",
                    staticStyle: { "font-size": "medium" },
                    attrs: { xs10: "" }
                  },
                  [_vm._v(_vm._s(email))]
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { xs2: "" } },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: { color: "primary" },
                        on: {
                          click: function($event) {
                            _vm.removeEmail(i)
                          }
                        }
                      },
                      [_vm._v("close")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                small: "",
                flat: "",
                outline: "",
                round: ""
              },
              on: {
                click: function($event) {
                  _vm.dtCurrentStep = 4
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t(_vm.lblSetting.ticketNext)))]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { flat: "", round: "", small: "" },
              on: {
                click: function($event) {
                  _vm.dtCurrentStep = 2
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t(_vm.lblSetting.ticketPrevious)))]
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-stepper-step",
        {
          attrs: {
            color: "secondary",
            complete: _vm.dtCurrentStep > 4,
            step: "4"
          }
        },
        [
          _c("h2", { staticClass: "primary--text" }, [
            _vm._v(_vm._s(_vm.$t(_vm.lblSetting.ticketSignature)))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "v-stepper-content",
        { attrs: { step: "4" } },
        [
          _c("div", { staticClass: "mb-2" }, [
            _vm.dtCurrentStep === 4
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      position: "absolute",
                      right: "20px",
                      display: "inline"
                    }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "mx-1",
                        attrs: {
                          flat: "",
                          outline: "",
                          color: "primary",
                          small: "",
                          round: "",
                          icon: ""
                        },
                        on: { click: _vm.handleUndo }
                      },
                      [_c("v-icon", [_vm._v("undo")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "ml-0",
                        attrs: {
                          flat: "",
                          outline: "",
                          color: "primary",
                          small: "",
                          round: "",
                          icon: ""
                        },
                        on: { click: _vm.handleClearSignature }
                      },
                      [_c("v-icon", [_vm._v("close")])],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  height: "42vh",
                  border: "1px dashed #DCDCDC",
                  "border-radius": "20px"
                }
              },
              [
                _c("VueSignaturePad", {
                  ref: "signaturePad",
                  attrs: { options: { onEnd: _vm.onEnd } }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { flat: "", round: "", small: "" },
              on: {
                click: function($event) {
                  _vm.dtCurrentStep = 3
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t(_vm.lblSetting.ticketPrevious)))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-516963cf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-516963cf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-modal-generate-intervention-report/template.html
// module id = null
// module chunks = 